"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromSnakecase2Headline = fromSnakecase2Headline;
exports.isValidImage = exports.parseArrayOfNumbers = exports.parseNumber = exports.getDomain = exports.toUnderscore = exports.formatTestId = exports.isValidUrl = exports.getPathOr = exports.isString = exports.isEmptyString = void 0;

var _ramda = require("ramda");

/**
 *
 * @param {string} value
 * @returns {boolean | value is null | undefined}
 */
var isEmptyString = function isEmptyString(value) {
  return (0, _ramda.or)((0, _ramda.isEmpty)(value), (0, _ramda.isNil)(value));
};
/**
 *
 * @param {*} value
 * @returns {boolean}
 */


exports.isEmptyString = isEmptyString;

var isString = function isString(value) {
  return typeof value === 'string';
};
/**
 *
 * @param {string} path
 * @param {any} defValue
 * @returns {(obj: any) => any}
 */


exports.isString = isString;

var getPathOr = function getPathOr(path) {
  var defValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _ramda.pathOr)(defValue, (0, _ramda.split)('.', path));
};
/**
 *
 * @param {string} value
 * @returns {boolean}
 */


exports.getPathOr = getPathOr;

var isValidUrl = function isValidUrl(value) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !value || pattern.test(value);
};
/**
 *
 * @param {string} testId
 * @returns {string}
 */


exports.isValidUrl = isValidUrl;

var formatTestId = function formatTestId(testId) {
  return testId.replace(/\s/g, '_');
};
/**
 *
 * @param {string} key
 * @returns {string}
 */


exports.formatTestId = formatTestId;

function fromSnakecase2Headline(key) {
  var head = key[0].toUpperCase();
  var tail = key.slice(1).split('_').join(' ');
  return head + tail;
}
/**
 * Replace whitespaces ro underscore symbol in the string.
 *
 * @param {string} value
 * @return {string}
 */


var toUnderscore = function toUnderscore(value) {
  return value.replace(/\s/g, '_').toLowerCase();
};
/**
 * Get domain from passed host.
 *
 * @param {string} host
 * @returns {string}
 *
 * @example
 *
 * getDomain('https://dashboard-pd-1234.alycedev.com') // .alycedev.com
 */


exports.toUnderscore = toUnderscore;

var getDomain = function getDomain(host) {
  var _URL = new URL(host),
      hostname = _URL.hostname;

  return hostname.slice(hostname.indexOf('.'));
};

exports.getDomain = getDomain;

var parseNumber = function parseNumber(str) {
  if (!str && str !== 0) {
    return undefined;
  }

  if (typeof str === 'number') {
    return str;
  }

  var value = parseFloat(str);
  return Number.isNaN(value) ? undefined : value;
};

exports.parseNumber = parseNumber;

var parseArrayOfNumbers = function parseArrayOfNumbers() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.split(',').map(function (num) {
    return Number(num);
  }).filter(Boolean);
};

exports.parseArrayOfNumbers = parseArrayOfNumbers;

var isValidImage = function isValidImage(imagePath) {
  var fileExtensionPattern = /\.(jpe?g|png|gif|bmp|svg)$/i;
  return fileExtensionPattern.test(imagePath);
};

exports.isValidImage = isValidImage;